import { useCallback, useState } from 'react';
import axios from 'axios';
import api from '@common/utils/api';
import analytics from '@stone/utils/analytics';
import einsteinutils from '@common/utils/einsteinutils';
const useProductsList = (itemListName, limit, product, productList, options) => {
    const [products, setProducts] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(true);
    const [recomName, setRecomName] = useState();
    const _limit = limit || 12;
    const sendAnalytics = useCallback((products) => {
        if ((products === null || products === void 0 ? void 0 : products.length) && itemListName && !(options === null || options === void 0 ? void 0 : options.noTrackInps)) {
            analytics.productImpressions({ products: products, index: 0, isScroll: true, item_list_name: itemListName });
        }
    }, [itemListName]);
    const cancelTokenSource = axios.CancelToken.source();
    const parseCategory = (category) => {
        var _a;
        return Object.assign(Object.assign({}, category), { recommender: category.recommender || category.recommenderId || category.reccomender, products_ids: (_a = ((category === null || category === void 0 ? void 0 : category.products_multiline) || (category === null || category === void 0 ? void 0 : category.productsMultiline) || category.listIds)) === null || _a === void 0 ? void 0 : _a.split(/\r?\n/), slot: category.slot });
    };
    const parseCategories = (categories) => {
        const arr = JSON.parse(categories);
        const newArr = [];
        arr.forEach((category) => {
            newArr.push(parseCategory(category));
        });
        return newArr;
    };
    const getProducts = async (category) => {
        var _a;
        if (category === null || category === void 0 ? void 0 : category.productTiles) {
            setProducts(category === null || category === void 0 ? void 0 : category.productTiles);
            setLoading(false);
            sendAnalytics(category === null || category === void 0 ? void 0 : category.productTiles);
        }
        else if ((_a = category === null || category === void 0 ? void 0 : category.products_ids) === null || _a === void 0 ? void 0 : _a.length) {
            const ids = category.products_ids.slice(0, _limit);
            await api.getProductTiles(ids).then((data) => {
                setProducts(data);
                setLoading(false);
                sendAnalytics(data);
            });
        }
        else if (category.category) {
            await api.searchProducts({ id: category.category, pageSize: _limit }).then((data) => {
                setProducts(data.products);
                setLoading(false);
                sendAnalytics(data.products);
            });
        }
        else if (category.recommender) {
            einsteinutils.productRecommendations(category.recommender, (rec) => {
                setProducts(rec.products);
                setLoading(false);
                sendAnalytics(rec.products);
            }, cancelTokenSource);
        }
        else if (category.slot) {
            einsteinutils.productRecommendationsFromSlot(category.slot, (recomName) => {
                setRecomName(recomName);
            }, (rec) => {
                var _a;
                const recommendedAreChanged = JSON.stringify(products === null || products === void 0 ? void 0 : products.map((el) => el.id).sort()) !== JSON.stringify((_a = rec === null || rec === void 0 ? void 0 : rec.products) === null || _a === void 0 ? void 0 : _a.map((el) => el.id).sort());
                if (recommendedAreChanged) {
                    // best way to decode special characters
                    let txt = document.createElement('textarea');
                    txt.innerHTML = rec.displayMessage;
                    setTitle(txt.value);
                    setProducts(rec.products);
                    sendAnalytics(rec.products);
                    setLoading(false);
                }
            }, cancelTokenSource, product, productList);
        }
        else {
            // no products will be fetched
            setLoading(false);
        }
    };
    const resetProducts = () => {
        setProducts(null);
        cancelTokenSource.cancel();
    };
    return {
        products: products,
        getProducts: getProducts,
        loading: loading,
        resetProducts: resetProducts,
        parseCategories: parseCategories,
        parseCategory: parseCategory,
        title: title,
        recomName: recomName,
    };
};
export default useProductsList;
